import { reportApis } from "@payping/api";
import { Card, Space, Typography } from "@payping/web-components";
import React from "react";
import { useAsync } from "react-use";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { addComma } from "@payping/utils/string";

const AllTimesStatCard: React.FC = () => {
  const { t } = useAppTranslation();

  const { value: amountRes } = useAsync(() => reportApis.v1ReportTotalUserGetPaidGet(), []);
  const { value: countRes } = useAsync(() => reportApis.v1ReportTotalGetPaidCountGet(), []);

  const amount = amountRes?.result;
  const count = countRes?.result;

  return (
    <Card.Raw>
      <Card.Raw.ColMeta header={<Card.Raw.RowMeta title={t("overview.allTimesValue")} />}>
        <Space>
          <Typography.Title level={1}>{addComma(amount)}</Typography.Title>
          <Typography.Title level={3}>{t("toman")}</Typography.Title>
        </Space>
      </Card.Raw.ColMeta>
      <Card.Raw.RowMeta showTopBorder title={t("overview.allTimesCount")}>
        <Card.Raw.NumericMeta size="secondary" value={count} />
      </Card.Raw.RowMeta>
    </Card.Raw>
  );
};

export default AllTimesStatCard;
